export default __webpack_public_path__ + "static/media/fasting_headaches@2x.c238baec.jpg";